<button #expansionButton (click)="openCollapsible(expansionButton, expansionPanel)" class="collapsible" type="button">{{ title | translate }}
</button>
<div #expansionPanel class="content collapsed">
	<ng-content></ng-content>
</div>